export default __webpack_public_path__ + "static/media/moves.1bad27bb.png";